import { createSelector } from 'reselect';
import { prop } from 'ramda';
import { selectCurrentKioskHomeRoute, selectIsKioskMode } from '../kiosk';
import { ROUTES } from '../../routes/routes';

export const selectHeaderBarDomain = prop('headerBar');

export const selectHeaderBarTheme = createSelector(
  selectHeaderBarDomain,
  prop('theme')
);

export const selectHomeRoute = createSelector(
  selectIsKioskMode,
  selectCurrentKioskHomeRoute,
  (isKiosk, kioskRoute) => {
    return isKiosk ? kioskRoute : ROUTES.home;
  }
);
